import { Card, IconButton, Paper, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, tableCellClasses } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { Button, CardBody, CardHeader, Spinner, Table } from 'reactstrap';
import { styled } from '@mui/material/styles';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import FeedIcon from '@mui/icons-material/Feed';
import AlertService from '../../../services/AlertService';
import CertificadoService from '../../../services/CertificadoService';
import { CasUserContext, useCasUserContext } from '../../../services/casUserContext';
import { useNavigate } from 'react-router-dom';
import UsuarioService from '../../../services/UsuarioService';
import { Categoria, DataSistema, ProductoEsperado } from '../../../interfaces/Sistema';
import CatalogService from '../../../services/CatalogService';
import { ModalEditarProductoEsperado } from './ModalEditarProductoEsperado';
const alertaService = new AlertService;
const certificadoService = new CertificadoService;
const usuarioservice = new UsuarioService;
const catalogoService = new CatalogService();

interface Column {
    id: 'tipoProducto'|'categoria'|'activo'|'opciones';
    label: string;
    minWidth?: number;
    align?: 'right';
    format?: (value: number) => string;
    
  }

  const columns: readonly Column[] = [
    { 
        id: 'tipoProducto', 
        label: 'Tipo de producto', 
     },
     {
        id: 'categoria',
        label: 'Categoria',
    },
    {
        id: 'activo',
        label: 'Activo',
    },
    {
        id: 'opciones',
        label: 'Opciones',
    }
  ];

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
    border: 0,
    },
}));

export default function TablaProductosEsperados(props: DataSistema){
    const [rowsPerPage, setRowsPerPage] = useState(props.rowsPerPage[0]);
    const [page, setPage] = useState(0);
    const [productosEsperados,setProductosEsperados] = useState<Array<ProductoEsperado>>([]);
    //const casUserContext = useContext(CasUserContext);
    const casUserContext = useCasUserContext();
    const token = casUserContext.token;
    const [openEditar, setOpenEditar] = useState(false);
    const [globalFilter, setGlobalFilter] = useState('');
    let [dataEditar, setDataEditar]=useState<number>(0);
    const abrirModalEditar=(data: number) =>{
        setOpenEditar(true)
        setDataEditar(data);
    }

    const cerrarModal=()=>{
        //setOpen(false)
        setOpenEditar(false)
    }

    const constFilteredCert = productosEsperados.filter((producto) => {
        if (producto.nombreProducto.toUpperCase().includes( globalFilter.toUpperCase()) || producto.nombreCategoria.toUpperCase().includes(globalFilter.toUpperCase()) ) {
            return true;
        }
            return false;
    });

    const fetchData = async () =>{
        try{
             alertaService.showLoading("Cargando Datos..."); 
             await catalogoService.GetProductosEsperadosTodos() 
             .then((data)=>{
                if(data.status.isSuccessfully){
                    setProductosEsperados(data.listData)
                }
             }) 
             .catch((error) => console.error(error));               
             alertaService.hideLoading();                
        }catch(error){
          console.error('Error:',error);
        }
      };

    useEffect(() => {
        fetchData();
        },[]);
    
    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    return(
        
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <Card>
            <ModalEditarProductoEsperado isOpen={openEditar} toggle={cerrarModal} data={dataEditar} />
            <CardBody>
                <div >
                    <div className='my-2 text-right'>
                        <input type="text" className='p-2 text-gray-600 border border-gray-300 rounded outline-indigo-700' placeholder='Buscar...' 
                             onChange={e=>setGlobalFilter(e.target.value)}
                        />
                    </div>
                </div>
            <TableContainer sx={{ maxHeight: 600 }}>
            <Table stickyheader="true" aria-label="sticky table" >
                <TableHead>
                <TableRow>
                {columns.map((column) => (                
                    <StyledTableCell 
                            style={{ minWidth: column.minWidth }}
                            key={column.id}
                            align={column.align}>
                        {column.label}
                        </StyledTableCell>
                    ))}
                </TableRow>
                </TableHead>
                <TableBody>
                    {
                        constFilteredCert.length>0 ? constFilteredCert
                        .slice(page * rowsPerPage, page*rowsPerPage+rowsPerPage)
                        .map((row, index)=>{
                            return(
                                <StyledTableRow key={index}>
                                    <StyledTableCell align="center">{row.nombreProducto}</StyledTableCell>
                                    <StyledTableCell align="center">{row.nombreCategoria}</StyledTableCell>  
                                    <StyledTableCell align="center">{row.activo==1 ? 'Si': 'No'}</StyledTableCell> 
                                    <StyledTableCell align="center">
                                        <IconButton color='primary' component="span" onClick={()=>abrirModalEditar(row.idProducto)}>
                                            <EditIcon />
                                        </IconButton>
                                    </StyledTableCell> 
                                </StyledTableRow>
                            )
                        })
                        :
                        <StyledTableRow key={0}>
                            <StyledTableCell align="center"></StyledTableCell>
                            <StyledTableCell align="center">No hay datos para presentar</StyledTableCell>  
                            <StyledTableCell align="center"></StyledTableCell> 
                            <StyledTableCell align="center"></StyledTableCell> 
                        </StyledTableRow>
                    }
                </TableBody>
            </Table>
            </TableContainer>
            <TablePagination
            rowsPerPageOptions={props.rowsPerPage}
            component="div"
            count={constFilteredCert.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            />
            </CardBody>
        </Card>      
    </Paper>
    )

}